import React from 'react';
import type { Question } from '../../../types/publicForm.types';
import { useFormContext } from './FormContext';
import { FormQuestion } from './FormQuestion';

interface ConditionalQuestionsProps {
  parentQuestion: Question;
  selectedValue: any;
  primaryColor: string;
}

export const ConditionalQuestions: React.FC<ConditionalQuestionsProps> = ({
  parentQuestion,
  selectedValue,
  primaryColor,
}) => {
  const { state } = useFormContext();
  
  if (!selectedValue || !parentQuestion.answers) {
    return null;
  }

  // Get all selected answer IDs
  const selectedAnswerIds = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
  
  // Collect all conditional questions from selected answers
  const conditionalQuestions: React.ReactNode[] = [];
  
  selectedAnswerIds.forEach(answerId => {
    const answer = parentQuestion.answers?.find(a => String(a.id) === String(answerId));
    if (answer?.childQuestions) {
      answer.childQuestions
        .filter(childQ => !childQ._destroy && state.visibleChildQuestions.has(childQ.id))
        .forEach(childQuestion => {
          conditionalQuestions.push(
            <div key={childQuestion.id} className="ml-8 mt-4 p-4 border-l-2 border-blue-300 bg-blue-50 rounded-r-lg">
              <FormQuestion
                question={childQuestion}
                primaryColor={primaryColor}
              />
            </div>
          );
        });
    }
  });
  
  return conditionalQuestions.length > 0 ? <>{conditionalQuestions}</> : null;
};